type CancelWorkflowChangeRequestBodyProps = {
    workflowName: string
}

export const CancelWorkflowChangeRequestBody = ({ workflowName }: CancelWorkflowChangeRequestBodyProps) => {
    return (
        <div>
            <p>This action will <b>CANCEL</b> the Change Request for the Verification Workflow named <b>{workflowName}</b>.</p>
            <p>
                Once the Change Request has been canceled, all undeployed changes that have been made will be rolled back and the Verification Workflow will be reverted back to its last deployed state.
                The changes that were made will be kept in the Verification Workflow History view and can be recovered as long as no additional changes are made to this Verification Workflow.
            </p>
        </div>
    );

} 